import { render, staticRenderFns } from "./AllReport.vue?vue&type=template&id=6f970b73&scoped=true"
import script from "./AllReport.vue?vue&type=script&lang=ts"
export * from "./AllReport.vue?vue&type=script&lang=ts"
import style0 from "./AllReport.vue?vue&type=style&index=0&id=6f970b73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f970b73",
  null
  
)

export default component.exports